import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormRef } from 'pages/PasswordReset/useFormRef';
import { useLocation } from 'react-router-dom';

export const EmailForm: FC = () => {
	const { pathname } = useLocation();
	const { t } = useTranslation();
	const [
		error,
		setError
	] = useState<Record<string, any>>({});

	const { formRef, checkValidity, isValid, onSubmit } = useFormRef();
	const [
		loading,
		setLoading
	] = useState(false);

	const [
		isEmailSent,
		setIsEmailSent
	] = useState(false);

	const resetPassword = async (body?: Record<string, any>) => {

		const params = new URLSearchParams();
		params.set('email', body?.email);
		params.set('redirectUrl', decodeURIComponent(window.location.origin + pathname));

		setLoading(true);
		fetch(`${import.meta.env.VITE_API_URL}/users/password/reset_token?${params.toString()}`)
			.then((response) => {
				if (response.status === 200) {
					setIsEmailSent(true);
					return;
				}
				return response.json();
			})
			.then((data) => {
				if (data.success === false) {
					setError(data);
				}
			})
			.catch(setError)
			.finally(() => setLoading(false));

	};
	return <>
		<form ref={formRef} className={'password-reset-form'}>
			{!isEmailSent && <>
				<p>{t('pages.forgotPassword.enterEmail')}</p>
				<input
					name="email"
					type="email"
					placeholder={t('pages.login.email')}
					required
					onInput={checkValidity}
					disabled={loading}
				/>
				<button
					onClick={onSubmit(resetPassword)}
					type={'submit'}
					className={'scroll-to-button active'}
					disabled={!isValid || loading}
				>
					{t('pages.forgotPassword.submit')}
				</button>
				{error && (
					<div className="error">{error?.message || (error as any)?.error}</div>
				)}
			</>}
			{isEmailSent && <p>{t('pages.forgotPassword.emailSent')}</p>}
		</form>
	</>;
};
